var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.nowProductObj
    ? _c(
        "div",
        { staticClass: "unlockSingle" },
        [
          _c("div", { staticClass: "unlockSingle__bg" }),
          _c("div", { staticClass: "unlockSingle__title" }, [
            _c("div", { staticClass: "unlockSingle__title__inside" }, [
              _c("h1", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.nowProductObj.Code == "All"
                        ? "全部購買"
                        : _vm.nowProductObj.cn + "座"
                    ) +
                    "\n      "
                )
              ]),
              _c("h2", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.nowProductObj.Code == "All"
                        ? _vm.nowProductObj.Name.split("-")[0]
                        : _vm.nowProductObj.en
                    ) +
                    "\n      "
                )
              ])
            ])
          ]),
          _c("div", {
            staticClass: "unlockSingle__quote",
            domProps: { innerHTML: _vm._s(_vm.nowProductObj.Description) }
          }),
          _c("div", { staticClass: "unlockSingle__intro" }, [
            _vm._m(0),
            _c("div", { staticClass: "unlockSingle__intro__content" }, [
              _c("div", {
                staticClass: "unlockSingle__intro__content__word",
                domProps: { innerHTML: _vm._s(_vm.nowProductObj.Introduction) }
              })
            ])
          ]),
          _c("div", { staticClass: "unlockSingle__toBuy" }, [
            _c(
              "div",
              {
                staticClass: "unlockSingle__toBuy__buyArea",
                class: { isAll: _vm.nowProductObj.Code == "All" }
              },
              [
                _vm.useType == "personal"
                  ? _c(
                      "div",
                      { staticClass: "unlockSingle__toBuy__buyArea__price" },
                      [
                        _c("span", [_vm._v("NT$")]),
                        _c("span", [_vm._v(_vm._s(_vm.nowProductObj.Amount))])
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "unlockSingle__toBuy__buyArea__btn",
                    class: { disabled: true },
                    on: {
                      click: function($event) {
                        return _vm.toBuy(_vm.nowProductObj)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.alreadyBuyPersonal ? "已購買" : "停止販售") +
                        "\n        "
                    ),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/運勢書共用/立即購買.svg"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]),
          _c("BuyNotice", { attrs: { notice: _vm.nowProductObj.Notice } }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAlreadyBuyToast,
                  expression: "showAlreadyBuyToast"
                }
              ],
              staticClass: "alreadyBuyToast"
            },
            [
              _vm._v("\n    本篇内容已解锁\n    "),
              _c("span", { staticClass: "hidden-mobile-down" }, [_vm._v("，")]),
              _c("br", { staticClass: "hidden-mobile-up" }),
              _vm._v("\n    不需要再进行购买啰~\n  ")
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "unlockSingle__intro__title" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/運勢書共用/解答之書介紹icon.svg"),
          alt: ""
        }
      }),
      _vm._v("\n      解答之书介绍\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }